import axios from "axios";
import { APIAnswer, APIAnswerData, CalpinFile, MLEvent, MLEventSaved, MLIMU, MLMeeting, MLRace, SkyRacingFile, Track, Venue, VenueInfo } from "../types";
import { authHeader, hasAuth } from "./auth.header";

/* -------------------------------------------------------------------------------- *\
|                               findapiserverurl
\* -------------------------------------------------------------------------------- */
export const findapiserverurl = (): string =>
{
    if (process.env.REACT_APP__API_URL) return process.env.REACT_APP__API_URL;

    const origin: string = window.location.origin;
    return origin.replace('3000', '5010').replace('3001', '5010');
}
/* -------------------------------------------------------------------------------- *\
|                               get_calpin
\* -------------------------------------------------------------------------------- */
export const get_calpin = async (): Promise<CalpinFile> =>
{
    if (!hasAuth()) return Promise.resolve({ updated: '', from: '', to: '', meetings: [] });
    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/calpin`, { headers: authHeader() }))
        .then(response => response.data as CalpinFile);
}
/* -------------------------------------------------------------------------------- *\
|                               get_skyracing
\* -------------------------------------------------------------------------------- */
export const get_skyracing = async (): Promise<SkyRacingFile> =>
{
    if (!hasAuth()) return Promise.resolve({ updated: '', from: '', to: '', meetings: [] });
    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/skyracing`, { headers: authHeader() }))
        .then(response => response.data as SkyRacingFile);
}
/* -------------------------------------------------------------------------------- *\
|                               get_meeting_list
\* -------------------------------------------------------------------------------- */
export const get_meeting_list = async (date: string): Promise<MLMeeting[]> =>
{
    if (!hasAuth())
    {
        return Promise.resolve([]);
    }
    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/meetings/${date}/full`, { headers: authHeader() }))
        .then(response => 
        {
            var meetings = response.data as MLMeeting[];
            return meetings;
        });
}
/* -------------------------------------------------------------------------------- *\
|                               get_eventsgnet_list
\* -------------------------------------------------------------------------------- */
export const get_eventsgnet_list = async (date: string, time: string): Promise<MLEvent[]> =>
{
    if (!hasAuth())
    {
        return Promise.resolve([]);
    }
    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/events/gnet/${date}/${time}`, { headers: authHeader() }))
        .then(response => 
        {
            return response.data as MLEvent[];
        });
}
/* -------------------------------------------------------------------------------- *\
|                               get_events_list
\* -------------------------------------------------------------------------------- */
export const get_events_list = async (date: string, time: number): Promise<MLEventSaved[]> =>
{
    if (!hasAuth())
    {
        return Promise.resolve([]);
    }
    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/events/sources/${date}/${time}`, { headers: authHeader() }))
        .then(response => 
        {
            return response.data as MLEventSaved[];
        });
}
/* -------------------------------------------------------------------------------- *\
|                               get_imu_list
\* -------------------------------------------------------------------------------- */
export const get_imu_list = async (date: string): Promise<MLIMU[]> =>
{
    if (!hasAuth())
    {
        return Promise.resolve([]);
    }
    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/imu/list/${date}`, { headers: authHeader() }))
        .then(response =>
        {
            return response.data as MLIMU[];
        });
}
/* -------------------------------------------------------------------------------- *\
|                               get_imu_infos
\* -------------------------------------------------------------------------------- */
export const get_imu_infos = async (imufile: MLIMU): Promise<any | null> =>
{
    if (!hasAuth())
    {
        return Promise.resolve(null);
    }
    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/imu/infos/${imufile.date}/${imufile.sic}/${imufile.number}`,
        {
            headers: authHeader(),
        }))
        .then(response =>
        {
            return response.data;
        });
}
/* -------------------------------------------------------------------------------- *\
|                               get_imu_file
\* -------------------------------------------------------------------------------- */
export const get_imu_file = async (imufile: MLIMU): Promise<Blob | null> =>
{
    if (!hasAuth())
    {
        return Promise.resolve(null);
    }
    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/imu/file/${imufile.date}/${imufile.sic}/${imufile.number}`,
        {
            headers: authHeader(),
            responseType: 'blob'
        }))
        .then(response =>
        {
            return response.data as Blob;
        });
}
/* -------------------------------------------------------------------------------- *\
|                               get_races
\* -------------------------------------------------------------------------------- */
export const get_races = async (date: string, sic: string): Promise<MLRace[]> =>
{
    if (!hasAuth())
    {
        return Promise.resolve([]);
    }
    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/races/${date}/${sic}`, { headers: authHeader() }))
        .then(response => 
        {
            return response.data as MLRace[];
        });
}
/* -------------------------------------------------------------------------------- *\
|                               get_race
\* -------------------------------------------------------------------------------- */
export const get_race = async (date: string, sic: string, norace: number): Promise<MLRace | null> =>
{
    if (!hasAuth())
    {
        return Promise.resolve(null);
    }
    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/race/${date}/${sic}/${norace}`, { headers: authHeader() }))
        .then(response => 
        {
            return response.data as MLRace;
        });
}
/* -------------------------------------------------------------------------------- *\
|                               import_file
\* -------------------------------------------------------------------------------- */
export const import_file = async (data: string): Promise<APIAnswer> =>
{
    if (!hasAuth())
    {
        return Promise.resolve({ status: false, message: 'Not authorized' });
    }
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/race/importfr`, { data: data }, { headers: authHeader() }))
        .then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               preview_import_file
\* -------------------------------------------------------------------------------- */
export const preview_import_file = async (data: string): Promise<APIAnswerData> =>
{
    if (!hasAuth())
    {
        return Promise.resolve({ status: false, message: 'Not authorized', data: null });
    }
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/race/previewimportfr`, { data: data }, { headers: authHeader() }))
        .then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               import_file_us
\* -------------------------------------------------------------------------------- */
export const import_file_us = async (data: string): Promise<APIAnswer> =>
{
    if (!hasAuth())
    {
        return Promise.resolve({ status: false, message: 'Not authorized' });
    }
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/race/importus`, { data: data }, { headers: authHeader() }))
        .then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               preview_import_file_us
\* -------------------------------------------------------------------------------- */
export const preview_import_file_us = async (data: string): Promise<APIAnswerData> =>
{
    if (!hasAuth())
    {
        return Promise.resolve({ status: false, message: 'Not authorized', data: null });
    }
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/race/previewimportus`, { data: data }, { headers: authHeader() }))
        .then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               import_file_qa
\* -------------------------------------------------------------------------------- */
export const import_file_qa = async (data: string, sic: string): Promise<APIAnswer> =>
{
    if (!hasAuth())
    {
        return Promise.resolve({ status: false, message: 'Not authorized' });
    }

    try
    {
        const response = await axios.post(
            findapiserverurl() + `/api/race/importqa`,
            { data: data, sic },
            { headers: authHeader() }
        );
        return response.data;
    } catch (error: any)
    {
        if (error.response?.data)
        {
            return error.response.data;
        }
        return {
            status: false,
            message: error.message || 'Server error'
        };
    }
}
/* -------------------------------------------------------------------------------- *\
|                               preview_import_file_qa
\* -------------------------------------------------------------------------------- */
export const preview_import_file_qa = async (data: string, sic: string): Promise<APIAnswerData> =>
{
    if (!hasAuth())
    {
        return Promise.resolve({ status: false, message: 'Not authorized', data: null });
    }

    try
    {
        const response = await axios.post(
            findapiserverurl() + `/api/race/previewimportqa`,
            { data: data, sic },
            { headers: authHeader() }
        );
        return response.data;
    } catch (error: any)
    {
        if (error.response?.data)
        {
            return error.response.data;
        }
        return {
            status: false,
            message: error.message || 'Server error',
            data: null
        };
    }
}
/* -------------------------------------------------------------------------------- *\
|                               removerace
\* -------------------------------------------------------------------------------- */
export const removerace = async (race: MLRace): Promise<boolean> =>
{
    if (!hasAuth())
    {
        return Promise.resolve(false);
    }
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/race/remove`, { data: race }, { headers: authHeader() }))
        .then(response => response.data);

}
/* -------------------------------------------------------------------------------- *\
|                               updaterace
\* -------------------------------------------------------------------------------- */
export const updaterace = async (race: MLRace): Promise<boolean> =>
{
    if (!hasAuth())
    {
        return Promise.resolve(false);
    }
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/race/update`, { data: race }, { headers: authHeader() }))
        .then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               get_venue_list
\* -------------------------------------------------------------------------------- */
export const get_venue_list = async (): Promise<Venue[]> =>
{
    if (!hasAuth())
    {
        return Promise.resolve([]);
    }
    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/venues`, { headers: authHeader() }))
        .then(response => 
        {
            var venues = response.data as Venue[];
            return venues;
        });
}
/* -------------------------------------------------------------------------------- *\
|                               get_sources_list
\* -------------------------------------------------------------------------------- */
export const get_sources_list = async (): Promise<string[]> =>
{
    if (!hasAuth())
    {
        return Promise.resolve([]);
    }
    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/sources`, { headers: authHeader() }))
        .then(response => 
        {
            var venues = response.data as string[];
            return venues;
        });
}
/* -------------------------------------------------------------------------------- *\
|                               get_track_list
\* -------------------------------------------------------------------------------- */
export const get_track_list = async (sic: string): Promise<Track[]> =>
{
    if (!hasAuth())
    {
        return Promise.resolve([]);
    }
    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/tracks/${sic}`, { headers: authHeader() }))
        .then(response => 
        {
            var venues = response.data as Track[];
            return venues;
        });
}
/* -------------------------------------------------------------------------------- *\
|                               create_venue
\* -------------------------------------------------------------------------------- */
export const create_venue = async (sic: string, name: string, source: string): Promise<APIAnswer> =>
{
    if (!hasAuth())
    {
        return Promise.resolve({ status: false, message: 'Not authorized' });
    }
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/venues/create`, { sic: sic, name: name, source: source }, { headers: authHeader() }))
        .then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               addmulti_venue
\* -------------------------------------------------------------------------------- */
export const addmulti_venue = async (infos: VenueInfo[], source: string): Promise<APIAnswerData> =>
{
    if (!hasAuth())
    {
        return Promise.resolve({ status: false, message: 'Not authorized', data: null });
    }
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/venues/addmulti`, { infos: infos, source: source }, { headers: authHeader() }))
        .then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               edit_venue
\* -------------------------------------------------------------------------------- */
export const edit_venue = async (sic: string, name: string, source: string): Promise<APIAnswer> =>
{
    if (!hasAuth())
    {
        return Promise.resolve({ status: false, message: 'Not authorized' });
    }
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/venues/edit`, { sic: sic, name: name, source: source }, { headers: authHeader() }))
        .then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               remove_venue
\* -------------------------------------------------------------------------------- */
export const remove_venue = async (sic: string): Promise<APIAnswer> =>
{
    if (!hasAuth())
    {
        return Promise.resolve({ status: false, message: 'Not authorized' });
    }
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/venues/remove`, { sic: sic }, { headers: authHeader() }))
        .then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               get_track_content
\* -------------------------------------------------------------------------------- */
export const get_track_content = async (sic: string, track: string): Promise<string> =>
{
    if (!hasAuth())
    {
        return Promise.resolve('');
    }
    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/track/${sic}/${track}`, { headers: authHeader() }))
        .then(response => 
        {
            var content = response.data as string;
            return content;
        });
}
/* -------------------------------------------------------------------------------- *\
|                               create_track
\* -------------------------------------------------------------------------------- */
export const create_track = async (sic: string, trackcode: string, distance: number, type: string, data: string): Promise<APIAnswer> =>
{
    if (!hasAuth())
    {
        const r: APIAnswer = { status: false, message: 'Not authorized' };
        return Promise.resolve(r);
    }
    const senddata = { sic: sic, trackcode: trackcode, distance: distance, type: type, data: data };
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/track/create`, senddata, { headers: authHeader() }))
        .then(response => 
        {
            var content = response.data as APIAnswer;
            return content;
        });
}
/* -------------------------------------------------------------------------------- *\
|                               delete_track
\* -------------------------------------------------------------------------------- */
export const delete_track = async (sic: string, trackcode: string): Promise<APIAnswer> =>
{
    if (!hasAuth())
    {
        const r: APIAnswer = { status: false, message: 'Not authorized' };
        return Promise.resolve(r);
    }
    const senddata = { sic: sic, trackcode: trackcode };
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/track/delete`, senddata, { headers: authHeader() }))
        .then(response => 
        {
            var content = response.data as APIAnswer;
            return content;
        });
}
/* -------------------------------------------------------------------------------- *\
|                               kmltocsv
\* -------------------------------------------------------------------------------- */
export const kmltocsv = async (content: string, corde: string, pcdep: number, width: number): Promise<APIAnswerData> =>
{
    if (!hasAuth())
    {
        const r: APIAnswerData = { status: false, message: 'Not authorized', data: null };
        return Promise.resolve(r);
    }
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/track/kmltocsv`, { content: content, corde: corde, pcdep: pcdep, width: width }, { headers: authHeader() }))
        .then(response => 
        {
            var content = response.data as APIAnswerData;
            return content;
        });
}
/* -------------------------------------------------------------------------------- *\
|                               csvtokml
\* -------------------------------------------------------------------------------- */
export const csvtokml = async (content: string): Promise<APIAnswerData> =>
{
    if (!hasAuth())
    {
        const r: APIAnswerData = { status: false, message: 'Not authorized', data: null };
        return Promise.resolve(r);
    }
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/track/csvtokml`, { content: content }, { headers: authHeader() }))
        .then(response => 
        {
            var content = response.data as APIAnswerData;
            return content;
        });
}
/* -------------------------------------------------------------------------------- *\
|                               get_race_sics
\* -------------------------------------------------------------------------------- */
export const get_race_sics = async (): Promise<{ sic: string; name: string; source: string; codes: string[] }[]> =>
{
    if (!hasAuth()) return [];
    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/race/sics`, { headers: authHeader() }))
        .then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               create_race
\* -------------------------------------------------------------------------------- */
export const create_race = async (race: MLRace, override: boolean = false): Promise<APIAnswer> =>
{
    if (!hasAuth()) return { status: false, message: 'Not authorized' };
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/race/create`, { data: race, override }, { headers: authHeader() }))
        .then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               get_settings_bdd
\* -------------------------------------------------------------------------------- */
export const get_settings_bdd = async (): Promise<{ status: boolean; users: { login: string; roles: string[] }[] }> =>
{
    if (!hasAuth()) return { status: false, users: [] };
    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/settings/bdd`, { headers: authHeader() }))
        .then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               save_settings_bdd
\* -------------------------------------------------------------------------------- */
export const save_settings_bdd = async (users: { login: string; roles: string[]; newPassword?: string }[]): Promise<APIAnswer> =>
{
    if (!hasAuth()) return { status: false, message: 'Not authorized' };
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/settings/bdd`, { users }, { headers: authHeader() }))
        .then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               get_settings_tracks
\* -------------------------------------------------------------------------------- */
export const get_settings_tracks = async (): Promise<{ status: boolean; content: string }> =>
{
    if (!hasAuth()) return { status: false, content: '' };
    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/settings/tracks`, { headers: authHeader() }))
        .then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               save_settings_tracks
\* -------------------------------------------------------------------------------- */
export const save_settings_tracks = async (content: string): Promise<APIAnswer> =>
{
    if (!hasAuth()) return { status: false, message: 'Not authorized' };
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/settings/tracks`, { content }, { headers: authHeader() }))
        .then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               get_settings_sources
\* -------------------------------------------------------------------------------- */
export const get_settings_sources = async (): Promise<{ status: boolean; sources: string[]; allSources: string[] }> =>
{
    if (!hasAuth()) return { status: false, sources: [], allSources: [] };
    return Promise.resolve()
        .then(() => axios.get(findapiserverurl() + `/api/settings/sources`, { headers: authHeader() }))
        .then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               save_settings_sources
\* -------------------------------------------------------------------------------- */
export const save_settings_sources = async (sources: string[]): Promise<APIAnswer> =>
{
    if (!hasAuth()) return { status: false, message: 'Not authorized' };
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/settings/sources`, { sources }, { headers: authHeader() }))
        .then(response => response.data);
}
/* -------------------------------------------------------------------------------- *\
|                               addkeys
\* -------------------------------------------------------------------------------- */
export const addkeys = async (content: string, keys: string): Promise<APIAnswerData> =>
{
    if (!hasAuth())
    {
        const r: APIAnswerData = { status: false, message: 'Not authorized', data: null };
        return Promise.resolve(r);
    }
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/track/addkeys`, { content: content, keys: keys }, { headers: authHeader() }))
        .then(response =>
        {
            var content = response.data as APIAnswerData;
            return content;
        });
}
/* -------------------------------------------------------------------------------- *\
|                               update_track
\* -------------------------------------------------------------------------------- */
export const update_track = async (sic: string, trackcode: string, content: string): Promise<APIAnswer> =>
{
    if (!hasAuth()) return Promise.resolve({ status: false, message: 'Not authorized' });
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/track/update`, { sic, trackcode, content }, { headers: authHeader() }))
        .then(response => response.data as APIAnswer);
}
/* -------------------------------------------------------------------------------- *\
|                               set_trackinfos
\* -------------------------------------------------------------------------------- */
export const set_trackinfos = async (sic: string, trackcode: string, type: string, distance: number): Promise<APIAnswer> =>
{
    if (!hasAuth()) return Promise.resolve({ status: false, message: 'Not authorized' });
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/track/setinfos`, { sic, trackcode, type, distance }, { headers: authHeader() }))
        .then(response => response.data as APIAnswer);
}
/* -------------------------------------------------------------------------------- *\
|                               add_yards
\* -------------------------------------------------------------------------------- */
export const add_yards = async (sic: string, trackcode: string): Promise<APIAnswer> =>
{
    if (!hasAuth()) return Promise.resolve({ status: false, message: 'Not authorized' });
    return Promise.resolve()
        .then(() => axios.post(findapiserverurl() + `/api/track/addyards`, { sic, trackcode }, { headers: authHeader() }))
        .then(response => response.data as APIAnswer);
}
